import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'typings/RootState'
import styled from 'styled-components'

import { getProjectType, getUnitList, getQCTypeList } from 'features/filter/api'
import { GetProjectTypeReq, GetQCTypeListReq } from 'features/filter/types'
import {
  selectProjectType,
  selectUnitList,
  selectQCTypeList,
} from 'features/filter/selector'
import { Col, Row } from 'antd'
import {
  projectsByIdSelector,
  selectedProjectCodeSelector,
} from 'features/project/project.selector'
import {
  serviceTokenSelector,
  userEmailSelector,
} from 'features/sensitive/sensitive.selector'
import { DropdownList, DropdownPopupMenu } from 'Components/Shared/Form'
import { fetchProjects } from 'features/project/project.api'
import { selectFilter } from 'features/adminReport/unit/selector'
import { Filter } from 'features/adminReport/unit/types'
import { updateFilter, clearFilter } from 'features/adminReport/unit/actions'
import UnitContent from 'Components/Shared/Filters/UnitContent'
import { GetUnitListReq } from 'features/filter/types'
import {
  ProjectsFilter,
  ProjectTypeFilter,
  DateFilter,
  ButtonFilter,
  QcTypeFilter,
} from './Components'
import MulticheckProject from 'Components/Shared/Filters/MulticheckProject'

type Props = {
  onSearch?: (isClear?: boolean) => void
  withPadding?: boolean
  onExport?: () => void
  exportData?: any[]
  isDownLoading?: boolean
} & ReduxProps &
  DispatchProps

const CommissioningFilter: React.FunctionComponent<Props> = props => {
  const {
    ProjectCode,
    UserEmail,
    token,
    filter,
    projectsById,
    onSearch = () => {},
    withPadding = false,
    projectType,
    unitList,
    qctypeList,
    onExport,
    exportData,
    isDownLoading,
  } = props

  useEffect(() => {
    dispatch(clearFilter())
    onGetProjectType()
    onGetUnitList()
    onGetQCTypeList()
    dispatch(fetchProjects({ email: UserEmail, token }))
    return () => {
      dispatch(clearFilter())
    }
  }, [ProjectCode, UserEmail])

  useEffect(() => {
    onGetUnitList()
  }, [filter.ProjectCode.length === 1])

  useEffect(() => {
    filter.UnitList = []
    onFilterChange(filter)
  }, [filter.ProjectCode.length !== 1])

  const onGetProjectType = () => {
    const req: GetProjectTypeReq = {
      UserEmail,
      Page: 1,
      RowPerPage: 100,
    }
    dispatch(getProjectType(token, req))
  }

  const onGetUnitList = () => {
    if (filter.ProjectCode && filter.ProjectCode.length === 1) {
      const req: GetUnitListReq = {
        ProjectCode: filter.ProjectCode[0],
        UserEmail,
        Zone: 'Resident Area',
      }
      dispatch(getUnitList(token, req))
    }
  }

  const onGetQCTypeList = () => {
    const req: GetQCTypeListReq = {
      UserEmail,
      UnitType: 'Unit',
      Status: 'Active',
    }
    dispatch(getQCTypeList(token, req))
  }

  const dispatch = useDispatch()
  const onFilterChange = (filter: Filter) => {
    console.log(filter)
    dispatch(updateFilter(filter))
  }

  const onClearSearch = () => {
    dispatch(clearFilter())
    onSearch(true)
  }

  const isFilter = () => {
    return (
      filter.UnitList.length > 0 ||
      filter.QCTypeList.length > 0 ||
      filter.Date.Mode !== '' ||
      filter.ProjectCode.length > 0 ||
      filter.ProjectTypeID !== 0
    )
  }

  const selectedProject =
    filter.ProjectCode.length > 0
      ? `เลือก ${filter.ProjectCode.length} โครงการ`
      : ''

  return (
    <MainPage className={withPadding ? 'with-padding' : ''}>
      <Row type="flex" justify="start">
        <Col span={8}>
          <ProjectTypeFilter
            filter={filter}
            onFilterChange={onFilterChange}
            projectType={projectType}
          />
        </Col>
        {/* <Col span={8}>
          <ProjectsFilter
            filter={filter}
            onFilterChange={onFilterChange}
            projectsById={projectsById}
          />
        </Col> */}
        <Col span={8}>
          <Box>
            <DropdownPopupMenu
              label={'โครงการ'}
              placeholder="เลือกโครงการ"
              value={filter.ProjectCode.join(',')}
              disabled={false}
              content={
                <MulticheckProject
                  projectList={projectsById}
                  projectTypeID={filter.ProjectTypeID}
                  filter={filter.ProjectCode}
                  onChange={data => {
                    filter.ProjectCode = data
                    onFilterChange(filter)
                  }}
                />
              }
              isActive={filter.ProjectCode.length > 0}
            />
          </Box>
        </Col>
        <Col span={8}>
          <Box>
            <DropdownPopupMenu
              label={'ยูนิต'}
              placeholder="เลือกยูนิต"
              value={filter.UnitList.join(',')}
              disabled={filter.ProjectCode.length !== 1}
              content={
                <UnitContent
                  units={unitList.List}
                  filter={filter.UnitList}
                  onChange={data => {
                    filter.UnitList = data
                    onFilterChange(filter)
                  }}
                />
              }
              isActive={filter.UnitList.length > 0}
            />
          </Box>
        </Col>
        <Col span={8}>
          <QcTypeFilter
            filter={filter}
            onFilterChange={onFilterChange}
            qctypeList={qctypeList}
          />
        </Col>
        <Col span={8}>
          <DateFilter filter={filter} onFilterChange={onFilterChange} />
        </Col>
        <Col span={8}>
          <Box>
            <DropdownList
              label="ตรวจโดย"
              value={filter.CheckedByRole}
              menu={['', 'QC', 'CM']?.map((item: any) => {
                return {
                  value: item,
                  name: item === '' ? 'ทั้งหมด' : item,
                }
              })}
              onChange={(value: any) => {
                filter.CheckedByRole = value
                onFilterChange(filter)
              }}
            />
          </Box>
        </Col>
        <Col span={8}>
          <ButtonFilter
            onClearSearch={onClearSearch}
            onSearch={onSearch}
            isFilter={isFilter()}
            onExport={onExport}
            isDownLoading={isDownLoading}
            exportData={exportData}
            fileName="รายงานตรวจงานมาตรฐาน (ยูนิต / แปลง) - รายงานตามยูนิต"
          />
        </Col>
      </Row>
    </MainPage>
  )
}

const MainPage = styled.div`
  margin-bottom: 24px;
  &.with-padding {
    padding: 0 120px;
  }

  background-color: #f5f6fa;
`

const Box = styled.div`
  padding: 0 12px 12px 0;
`
const Margin = styled.div`
  margin: 20px;
`

const mapStateToProps = (state: RootState) => {
  return {
    ProjectCode: selectedProjectCodeSelector(state),
    UserEmail: userEmailSelector(state),
    token: serviceTokenSelector(state),
    filter: selectFilter(state),
    unitList: selectUnitList(state),
    qctypeList: selectQCTypeList(state),
    projectType: selectProjectType(state),
    projectsById: projectsByIdSelector(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const mapDispatchToProps = {}

type DispatchProps = typeof mapDispatchToProps

export default connect(mapStateToProps, mapDispatchToProps)(CommissioningFilter)
